const Pagination = ({ pagination, onPageChange, compact = false, variant = 'cream' }) => {
  // Handle null/undefined pagination gracefully
  if (!pagination) {
    return null;
  }

  const { currentPage, totalPages, hasPrevPage, hasNextPage } = pagination;
  

  const changePage = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  if (totalPages <=1) {
    return null;
  }

  const theme = variant === 'theme';

  const wrap = theme
    ? compact
      ? 'flex w-full items-center justify-between rounded-lg border border-border-strong bg-surface px-3 py-2 font-mono text-[10px] text-secondary'
      : 'flex w-full items-center justify-between rounded-xl border border-border-strong bg-surface px-4 py-3 font-mono text-[11px] text-secondary'
    : compact
      ? 'flex w-full items-center justify-between rounded-lg border border-cream/60 bg-white px-3 py-2 text-[10px] text-slate-600'
      : 'flex w-full items-center justify-between rounded-xl border border-cream/60 bg-white px-4 py-3 text-sm text-slate-600';
  const btn = theme
    ? compact
      ? 'rounded-md border border-border-strong bg-surface-muted/50 px-2 py-0.5 text-[10px] font-medium text-primary transition hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-40'
      : 'rounded-lg border border-border-strong bg-surface-muted/50 px-3 py-1 text-[11px] font-medium text-primary transition hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-40'
    : compact
      ? 'rounded-md border border-cream/60 px-2 py-0.5 text-[10px] font-medium transition hover:bg-cream/60 disabled:cursor-not-allowed disabled:opacity-40'
      : 'rounded-lg border border-cream/60 px-3 py-1 transition hover:bg-cream/60 disabled:cursor-not-allowed disabled:opacity-40';
  const pageLabel = theme
    ? compact
      ? 'flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-primary'
      : 'flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-primary'
    : compact
      ? 'flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.14em] text-primary-dark'
      : 'flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.3em] text-primary-dark';
  const icon = compact ? 'h-3 w-3 shrink-0' : 'h-4 w-4 shrink-0';

  return (
    <div className={wrap}>
      <button type="button" onClick={() => changePage(currentPage - 1)} disabled={!hasPrevPage} className={btn}>
        Previous
      </button>

      <span className={pageLabel}>
        <svg className={icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
        Page {currentPage} of {totalPages}
      </span>

      <button type="button" onClick={() => changePage(currentPage + 1)} disabled={!hasNextPage} className={btn}>
        Next
      </button>
    </div>
  );
};

export default Pagination;

